export default __webpack_public_path__ + "static/media/list_main_2_1.fad1f181.png";